import { DetailWrapper } from "../../../../../features/ui"
import { EmployeeDetail } from "./employeeDetail"

export const EmployeeDetailLoader = () => (
    <DetailWrapper>
        <EmployeeDetail />
    </DetailWrapper>
)
